import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/incoming_email_log_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
const IncomingEmailLogSchema = withDefaults({
  type: 'incoming-email-log',
  fields: [
    { kind: 'attribute', name: 'batch' },
    { kind: 'attribute', name: 'documentUploadStatus' },
    { kind: 'attribute', name: 'documentUploadErrors' },
    { kind: 'attribute', name: 'emailContent' },
    { kind: 'attribute', name: 'fromAddress' },
    { kind: 'attribute', name: 'toAddress' },
    { kind: 'belongsTo', name: 'person', type: 'person', options: { async: false, inverse: null } },
  ],
});

export default IncomingEmailLogSchema;
